import type { Vehicle } from '@/fleet/domain/vehicle';

// One vehicle being registered in step 2. Mirrors the pendingVehicle shape (see
// fleet/application/pendingVehicleSlice.ts) but stays local to the wizard draft — nothing here is
// persisted until the wizard's final Confirm (see quickRegistrationController.submit).
export interface QuickRegistrationVehicleDraft extends Partial<Vehicle> {
    // A stable local key (not a backend id) so the UI can key/edit/remove list rows before any
    // vehicle has been saved.
    draftId: string;
    compatibility: 'unknown' | 'compatible' | 'incompatible';
    incompatibleReasons: string[];
}

export interface QuickRegistrationDraft {
    groupName: string;
    adminEmails: string[];
    vehicles: QuickRegistrationVehicleDraft[];
}

export const makeEmptyQuickRegistrationDraft = (): QuickRegistrationDraft => ({
    adminEmails: [''],
    groupName: '',
    vehicles: [],
});

export const makeEmptyVehicleDraft = (draftId: string): QuickRegistrationVehicleDraft => ({
    compatibility: 'unknown',
    draftId,
    incompatibleReasons: [],
    licensePlate: '',
    licensePlateCountryCode: '',
});
